<template>
  <div class="input-search-container">
    <div class="input-wrapper" :class="{'input-wrapper-more': computedList.length>0}">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.4733 12.5266L10.9999 10.0733C11.96 8.87621 12.4249 7.3568 12.2991 5.82747C12.1733 4.29814 11.4664 2.87512 10.3236 1.85103C9.18085 0.82694 7.68914 0.27961 6.15522 0.321583C4.62129 0.363557 3.16175 0.991644 2.0767 2.0767C0.991644 3.16175 0.363557 4.62129 0.321583 6.15522C0.27961 7.68914 0.82694 9.18085 1.85103 10.3236C2.87512 11.4664 4.29814 12.1733 5.82747 12.2991C7.3568 12.4249 8.87621 11.96 10.0733 10.9999L12.5266 13.4533C12.5886 13.5158 12.6623 13.5654 12.7436 13.5992C12.8248 13.633 12.9119 13.6505 12.9999 13.6505C13.0879 13.6505 13.1751 13.633 13.2563 13.5992C13.3376 13.5654 13.4113 13.5158 13.4733 13.4533C13.5934 13.329 13.6606 13.1628 13.6606 12.9899C13.6606 12.817 13.5934 12.6509 13.4733 12.5266ZM6.33327 10.9999C5.41029 10.9999 4.50804 10.7262 3.74061 10.2135C2.97318 9.70068 2.37504 8.97185 2.02183 8.11913C1.66862 7.2664 1.57621 6.32809 1.75627 5.42285C1.93634 4.5176 2.38079 3.68608 3.03344 3.03344C3.68608 2.38079 4.5176 1.93634 5.42285 1.75627C6.32809 1.57621 7.2664 1.66862 8.11913 2.02183C8.97185 2.37504 9.70068 2.97318 10.2135 3.74061C10.7262 4.50804 10.9999 5.41029 10.9999 6.33327C10.9999 7.57095 10.5083 8.75793 9.6331 9.6331C8.75793 10.5083 7.57095 10.9999 6.33327 10.9999Z" fill="#787878"/>
      </svg>
      <input type="text" placeholder="검색"
             v-model="value" @keyup="e => value = e.target.value" @keyup.enter="onEnter">
    </div>
    <template v-if="computedList.length>0" >
      <div class="dim" @click="value = ''"></div>
      <div class="list-search">
      <div class="list-search-wrapper">
        <div v-for="(item,idx) in computedList" :key="`search-item-${idx}`"
          class="item-search unselect" @click="clickItem(item)">
          <div style="padding-right:12px">
            {{ item.name }}<div class="desc-search">{{ item.path_name }}</div>
          </div>
          <svg width="8" height="9" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.94667 4.24646C7.91494 4.16463 7.86736 4.08987 7.80667 4.02646L4.47333 0.693131C4.41117 0.630972 4.33738 0.581665 4.25617 0.548025C4.17495 0.514385 4.08791 0.49707 4 0.49707C3.82247 0.49707 3.6522 0.567596 3.52667 0.693131C3.46451 0.75529 3.4152 0.829084 3.38156 0.910299C3.34792 0.991513 3.33061 1.07856 3.33061 1.16646C3.33061 1.344 3.40113 1.51426 3.52667 1.6398L5.72667 3.83313H0.666667C0.489856 3.83313 0.320287 3.90337 0.195262 4.02839C0.070238 4.15342 0 4.32299 0 4.4998C0 4.67661 0.070238 4.84618 0.195262 4.9712C0.320287 5.09623 0.489856 5.16646 0.666667 5.16646H5.72667L3.52667 7.3598C3.46418 7.42177 3.41459 7.49551 3.38074 7.57675C3.34689 7.65799 3.32947 7.74512 3.32947 7.83313C3.32947 7.92114 3.34689 8.00828 3.38074 8.08952C3.41459 8.17075 3.46418 8.24449 3.52667 8.30646C3.58864 8.36895 3.66238 8.41855 3.74362 8.45239C3.82486 8.48624 3.91199 8.50366 4 8.50366C4.08801 8.50366 4.17515 8.48624 4.25638 8.45239C4.33762 8.41855 4.41136 8.36895 4.47333 8.30646L7.80667 4.97313C7.86736 4.90973 7.91494 4.83497 7.94667 4.75313C8.01335 4.59082 8.01335 4.40877 7.94667 4.24646Z" fill="#AEAEAE"/>
          </svg>
        </div>
      </div>
    </div>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'InputSearch',
    created() {
    },
    data() {
      return {
        value: '',
        allPackages: ['call', 'delivery', 'reservation', 'booking', 'meet', 'counsel', 'outlink', 'estimate',
                      'commerce', 'mart']
      }
    },
    computed: {
      computedList() {
        return this.value.trim() === '' ? [] :
          this.list.filter(i => i.path_name ? i.path_name.indexOf(this.value.trim())>-1 : i.name.indexOf(this.value.trim())>-1);
      },
      list() {
        this.$store.getters.menus.forEach(i => {
          i.path_name = i.name;
          if(i.child) {
            i.child.forEach(j => {
              if(i.plugin && !j.plugin) {
                j.plugin = i.plugin;
              }
              j.path_name = `${i.path_name} > ${j.name}`;
              if(j.child) {
                j.child.forEach(k => {
                  if(j.plugin && !k.plugin) {
                    k.plugin = j.plugin;
                  }
                  k.path_name = `${j.path_name} > ${k.name}`;
                  if(k.child) {
                    k.child.forEach(l => {
                      l.path_name = `${k.path_name} > ${l.name}`;
                      if(k.plugin && !l.plugin) {
                        l.plugin = k.plugin;
                      }
                    });
                  }
                });
              }
            })
          }
        });

        return this.$store.getters.menus.reduce((a, c) =>
          a.concat(c.child ? c.child.reduce((childAcc, child) =>
            childAcc.concat(child.child ?
              child.child.reduce((gchildAcc, gchild) =>
                gchildAcc.concat(gchild.child ?
                  gchild.child : [gchild]), [])
              : [child]),
            [])
            : [c],
            []),
          [])
          .filter(i => (!i.plugin || this.isInternalPlugin(i.plugin)) && this.isPackage(i));
      }
    },
    methods: {
      onEnter() {
        if(this.value.trim() === '') {
          return;
        }
        this.$store.commit('setSearchResult', {
          value: this.value,
          list: this.cloneItem(this.computedList)
        });
        this.routerPush(this.getPath('search_result'));
        this.value = '';
      },
      clickItem(item) {
        this.routerPush(this.getPath(item.path));
        this.value = '';
      },
      isPackage(item) {
        if(this.allPackages.some( i => item.menu_id.startsWith(i))) {
          return this.$store.getters.getPackages.some(i => item.menu_id.startsWith(i.name));
        } else {
          return true;
        }
      }
    },
  }
</script>

<style lang="stylus" scoped>
  .input-wrapper
    display flex
    align-items center
    gap 0 8px
    background-color #eeeeee
    color #363636
    padding 6px 8px
    border-radius 6px
    width 280px
  .input-wrapper-more
    border-bottom-left-radius 0
    border-bottom-right-radius 0

  input[type="text"]
    width 100%
    background-color transparent
    border 0
    font-size 13px
  input[type="text"]:focus
    outline 0

  .input-search-container
    position relative

  .dim
    position fixed
    z-index 1
    top 50px
    left 0
    width 100vw
    height 100vh
  .list-search
    position absolute
    width 280px
    left 0
    z-index 10
    border-bottom-left-radius 6px
    border-bottom-right-radius 6px
    overflow hidden
    box-shadow 0 5px 10px 0 rgba(0,0,0,0.15)
    border-top 1px solid #cccccc
  .list-search-wrapper
    background-color white
    width 100%
    max-height 300px
    overflow-y auto
  .item-search
    display flex
    justify-content space-between
    align-items center
    color #363636
    font-size 13px
    padding 8px 12px
    text-align left
  .item-search:hover
    background-color #f5f5f5

  .desc-search
    font-size 11px
    color #989898
    margin-top 2px
</style>
